<template>
  <div>
    <v-navigation-drawer fixed clipped app v-model="drawer" v-if="auth.isLogged">
      <v-list dense>
        <template v-for="(item, i) in items">
          <v-layout row v-if="item.heading" align-center :key="i" >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group v-else-if="item.children" v-model="item.model" no-action>
            <v-list-tile slot="item" @click="">
              <v-list-tile-action>
                <v-icon>{{ item.model ? item.icon : item['icon-alt'] }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title >
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i" @click="" >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else @click="">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <router-link :to="item.to">
                  {{ item.text }}
                </router-link>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar :color="this.getTheme.color" dark app clipped-left fixed v-if="auth.isLogged">
      <v-toolbar-title :style="$vuetify.breakpoint.smAndUp ? 'width: 300px; min-width: 250px' : 'min-width: 72px'" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-xs-only">Agendamento</span>
      </v-toolbar-title>
      <!-- <v-text-field light solo prepend-icon="search" placeholder="Busca" style="max-width: 500px; min-width: 128px"></v-text-field> -->
      <div class="d-flex align-center" style="margin-left: auto">

        <div v-if="this.auth.isLogged">

          <v-menu
            offset-x
            :close-on-content-click="false"
            :nudge-width="200"
            v-model="menu"
          >
            <v-btn icon slot="activator" dark @click.native="show = !show">
              <v-badge color="this.getTheme.color" v-model="show" left>
                <span slot="badge">3</span>
                <v-icon>notifications</v-icon>
              </v-badge>
            </v-btn>
            <v-layout row justify-center>
              <v-flex xs12>
              <v-card>
                <v-list>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <img src="../assets/Logo_Spitzer_icone.png" alt="Sptizer.io">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{auth.user.name.toUpperCase()}}</v-list-tile-title>
                      <v-list-tile-sub-title>Spitzer.io</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn
                        icon
                        :class="fav ? 'red--text' : ''"
                        @click="fav = !fav"
                      >
                        <v-icon>favorite</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-switch v-model="message" :color="this.getTheme.color"></v-switch>
                    </v-list-tile-action>
                    <v-list-tile-title>Notificações</v-list-tile-title>
                  </v-list-tile>
                  <!-- <v-list-tile>
                    <v-list-tile-action>
                      <v-switch v-model="hints" color="purple"></v-switch>
                    </v-list-tile-action>
                    <v-list-tile-title>Enable hints</v-list-tile-title>
                  </v-list-tile> -->
                </v-list>

                <v-list two-line>
                  <template v-for="item in itemsNotification">
                    <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
                    <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
                    <v-list-tile avatar v-else v-bind:key="item.title" @click="">
                      <v-list-tile-avatar>
                        <img v-bind:src="item.avatar">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.title"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!-- <v-btn flat @click="menu = false">Cancel</v-btn> -->
                  <v-btn color="primary" @click="menu = false">Sair</v-btn>
                </v-card-actions>
              </v-card>
              </v-flex>
            </v-layout>
          </v-menu>

          <v-menu bottom left>
            <v-btn icon slot="activator" dark>
              <v-avatar size="32px" tile>
                <!-- <img src="https://vuetifyjs.com/static/doc-images/logo.svg" alt="spitzer.io"> -->
                <img src="../assets/Logo_Spitzer_icone_braco.png" alt="Sptizer.io">
              </v-avatar>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in menuItems" :key="item.title">
                <router-link :to="item.to">
                  <v-list-tile-title @click.prevent="actionMenu(item.action)">{{ item.title }}</v-list-tile-title>
                </router-link>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div v-else>
          <router-link to="/login">
            <v-btn icon>
              <v-icon>exit_to_app</v-icon>
            </v-btn>
          </router-link>
        </div>

      </div>
    </v-toolbar>

    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-container fluid style="min-height: 0;" grid-list-lg>

            <v-fade-transition mode="out-in">
              <router-view></router-view>
            </v-fade-transition>

          </v-container>
        </v-layout>
      </v-container>
    </v-content>

    <!-- <v-btn fab bottom right color="pink" dark fixed @click.stop="dialog = !dialog">
      <v-icon>add</v-icon>
    </v-btn> -->
    <!-- <v-footer class="pa-3" :fixed="footerAbsolute"> -->
    <!-- <v-footer class="pa-3">
      <v-spacer></v-spacer>
      <div>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</div>
    </v-footer> -->
  </div>
</template>

<script>
  import localforage from 'localforage'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    data: () => ({
      footerAbsolute: true,
      show: true,
      fav: true,
      menu: false,
      message: true,
      hints: true,
      drawer: null,
      lastFiveDays: {
        min: null,
        max: null
      },
      menuItems: [
        { title: 'Perfil', to: '/patient/profile', action: 'perfil' },
        { title: 'Sair', to: '/patient/login', action: 'sair' }
      ],
      items: [
        { icon: 'home', text: 'Inicio', href: 'home', router: true, to: '/' },
        { icon: 'history', text: 'Histórico', href: 'customer', router: true, to: '/patient/history' },
        { icon: 'contacts', text: 'Perfil', href: 'patientProfile', router: true, to: '/patient/profile' },
        { icon: 'lock', text: 'Redefinir Senha', href: 'recoveryProfile', router: true, to: '/patient/recovery-password' }
      ],
      itemsNotification: [
        { header: '16/01/2017' },
        { avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png', title: 'Cadastro', subtitle: "<span class='grey--text text--darken-2'>Bem vindo</span> — Seu cadastro foi efetuado com sucesso" },
        { divider: true, inset: true },
        { avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png', title: 'Agendamento <span class="grey--text text--lighten-1"></span>', subtitle: "<span class='grey--text text--darken-2'>Agendamento</span> — Agora você pode agendar sua consulta." },
        { divider: true, inset: true },
        { avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png', title: 'Notícia', subtitle: "<span class='grey--text text--darken-2'>Àgua</span> — A água faz muito bem ao organismo, ela atua em todas as funções do corpo (circulação, digestão, excreção)." }
      ]
    }),
    methods: {
      ...mapActions(['setUser']),
      ...mapActions('schedule', ['setList', 'setAvailableAppointments']),
      actionMenu (value) {
        if (value === 'sair') {
          this.logout()
        } else if (value === 'perfil') {
          this.$router.push('/patient/profile')
        }
      },
      logout () {
        localforage.removeItem('token')
        localforage.removeItem('user')
        const auth = {
          isLogged: false,
          token: '',
          user: {
            username: null,
            id: '',
            client: '',
            name: '',
            healthInsurance: null,
            code: ''
          }
        }
        this.setList({})
        this.setUser(auth)
        this.$router.push('/patient/login')
      }
    },
    props: {
      source: String
    },
    mounted () {
      // this.$vuetify.theme.primary = '#00d1b2'
      // console.log(this.getTheme.color)
    },
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('app', ['getTheme'])
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue